import { Sunrise, Rocket, Sparkles, Building2, Users, Flag } from "lucide-react";

const milestones = [
  { year: "2025", icon: Sunrise, title: "A Vision Takes Root", desc: "Aarohi Welfare Foundation dreams of a play school rooted in Bharatiya values.", color: "bg-orange-500" },
  { year: "2026", icon: Building2, title: "Foundations Laid", desc: "Curriculum designed blending Sanatan wisdom with modern early-childhood science.", color: "bg-amber-500" },
  { year: "Jan 2027", icon: Rocket, title: "Grand Launch", desc: "Aadi Gayanam opens its doors to little learners in Jaipur.", color: "bg-red-500" },
  { year: "2028", icon: Users, title: "Growing Family", desc: "Expanding programs and welcoming more children into our warm learning home.", color: "bg-orange-600" },
  { year: "2030+", icon: Sparkles, title: "Dream Bigger", desc: "Multiple branches, sanskaar workshops and a franchise network across Bharat.", color: "bg-fuchsia-500" },
  { year: "Forever", icon: Flag, title: "Rooted & Rising", desc: "Continuing to shape rooted, curious and confident children of Bharat.", color: "bg-emerald-600" }
];

const JourneyInfographic = () => (
  <section className="py-16 bg-gradient-to-br from-orange-50 via-amber-50 to-rose-50 relative overflow-hidden" data-testid="journey-infographic">
    <div className="absolute inset-0 opacity-10 pointer-events-none">
      <div className="absolute top-10 left-10 w-60 h-60 border-2 border-orange-400 rounded-full" />
      <div className="absolute bottom-10 right-10 w-80 h-80 border-2 border-amber-400 rounded-full" />
    </div>
    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">Our Journey</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">A Timeline of Big Dreams</h2>
        <p className="text-stone-600 text-sm md:text-base">Every great tree begins as a single seed. Here's ours.</p>
      </div>

      <div className="relative">
        {/* Vertical timeline line */}
        <div className="absolute left-1/2 top-4 bottom-4 w-1 bg-gradient-to-b from-orange-300 via-amber-400 to-emerald-400 -translate-x-1/2 hidden md:block" />

        <div className="space-y-8">
          {milestones.map((m, i) => {
            const Icon = m.icon;
            const isLeft = i % 2 === 0;
            return (
              <div key={m.year} className="md:grid md:grid-cols-2 md:gap-8 items-center relative" data-testid={`milestone-${m.year.toLowerCase().replace(/[^a-z0-9]/g, "")}`}>
                {isLeft ? (
                  <>
                    <div className="md:text-right md:pr-10">
                      <TimelineCard m={m} Icon={Icon} align="right" />
                    </div>
                    <div className="hidden md:block" />
                  </>
                ) : (
                  <>
                    <div className="hidden md:block" />
                    <div className="md:pl-10">
                      <TimelineCard m={m} Icon={Icon} align="left" />
                    </div>
                  </>
                )}
                {/* dot */}
                <div className={`hidden md:flex absolute left-1/2 top-8 -translate-x-1/2 w-8 h-8 rounded-full ${m.color} border-4 border-white shadow-lg items-center justify-center`}>
                  <Icon className="w-3.5 h-3.5 text-white" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

const TimelineCard = ({ m, Icon, align }) => (
  <div className="inline-block bg-white rounded-2xl p-5 shadow-lg border border-orange-100 hover:shadow-2xl transition-all text-left max-w-md md:hover:-translate-y-1">
    <div className={`inline-flex items-center gap-2 mb-2 ${align === "right" ? "md:flex-row-reverse" : ""}`}>
      <div className={`w-10 h-10 rounded-xl ${m.color} flex items-center justify-center shadow md:hidden`}>
        <Icon className="w-5 h-5 text-white" />
      </div>
      <span className={`inline-block px-3 py-1 rounded-full text-[10px] font-bold text-white uppercase tracking-widest ${m.color}`}>{m.year}</span>
    </div>
    <h3 className="font-display text-lg font-bold text-stone-800">{m.title}</h3>
    <p className="text-sm text-stone-600 leading-relaxed">{m.desc}</p>
  </div>
);

export default JourneyInfographic;
